import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Homepage from './components/pages/Homepage';
import Loginpage from './components/pages/Loginpage';
import AdminPage from './components/pages/AdminPage';
import ReportsPage from './components/pages/ReportsPage';
import ActivityLogsPage from './components/pages/ActivityLogsPage';
import { getStoredUser, logPageVisit } from './api';

function ActivityTracker({ userRole }) {
  const location = useLocation();
  useEffect(() => {
    if (userRole) logPageVisit(location.pathname);
  }, [location.pathname, userRole]);
  return null;
}

function App() {
  const stored = getStoredUser();
  const [userRole,  setUserRole]  = useState(stored?.role  || '');
  const [userEmail, setUserEmail] = useState(stored?.email || '');

  const authProps = { userRole, userEmail };

  return (
    <Router>
      <ActivityTracker userRole={userRole} />
      <Routes>
        <Route path="/"
          element={<Loginpage setUserRole={setUserRole} setUserEmail={setUserEmail} />} />
        <Route path="/Homepage"
          element={userRole ? <Homepage {...authProps} /> : <Navigate to="/" replace />} />
        <Route path="/reports"
          element={userRole ? <ReportsPage {...authProps} /> : <Navigate to="/" replace />} />
        <Route path="/admin"
          element={userRole === 'superadmin' ? <AdminPage {...authProps} /> : <Navigate to="/" replace />} />
        <Route path="/activity-logs"
          element={userRole === 'superadmin' ? <ActivityLogsPage {...authProps} /> : <Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
